export default __webpack_public_path__ + "static/media/palta-error.5649a060.png";